import {
  useCurrentClientManager,
  CurrentUser,
  UserEntitlement,
  Entitlement,
} from '@cko/dashboard-shared';
import { useQuery, QueryKey } from '@tanstack/react-query';

import { API_PATHS } from '../../../../environment/apiPaths';
import { CurrentUserResponseData, useGetCurrentUserFetcher } from './useGetCurrentUserFetcher';

const mapToUserEntitlement = (entitlement: {
  type: Entitlement;
  client_id: string;
  entity_id: string;
}): UserEntitlement => {
  return {
    type: entitlement.type,
    clientId: entitlement.client_id,
    entityId: entitlement.entity_id,
  };
};

const mapToCurrentUser = (data: CurrentUserResponseData): CurrentUser => {
  const currentUser: CurrentUser = {
    id: data.user_id,
    fullName: `${data.first_name || ''} ${data.last_name || ''}`.trim(),
    firstName: data.first_name,
    lastName: data.last_name,
    email: data.email,
    current_role_names: data.current_role_names,
    entitlements: data.user_entitlements ? data.user_entitlements.map(mapToUserEntitlement) : [],
    isFederated: data.is_federated,
    data: data,
  };

  return currentUser;
};

const API_PATH = `${API_PATHS.userManagementApiBasePath}/umt/users/self`;

export const useGetCurrentUser = () => {
  const { client, entity, subEntity } = useCurrentClientManager();
  const fetcher = useGetCurrentUserFetcher();
  const isEnabled = Boolean(client?.id || subEntity?.id);
  const queryKey: QueryKey = [API_PATH, { clientId: client?.id, entityId: entity?.id }];

  return useQuery<CurrentUserResponseData, Error, CurrentUser>(queryKey, fetcher, {
    enabled: isEnabled,
    staleTime: 24 * 60 * 60 * 1000, // Day
    select: mapToCurrentUser,
  });
};
